module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_paperEggshell-aae2b8747bd08825bf9550bf70a9549e.jpg";